import React from "react";
import { useTranslation } from "react-i18next";
function ProfileDataList({ customer, customerFields, showAll }) {
    const { t } = useTranslation();
    return (
        <div className="profile-box">
            {customerFields.length > 0 &&
                customerFields.map(
                    (item) =>
                        (showAll || item.visibility) &&
                        (item.isNative ? (
                            <div key={item.key}>
                                <p className="opt-subtitle">{t(`clientForm.${item.key}`)}</p>
                                <p className="opt-label">
                                    {customer &&
                                        (customer[item.key]
                                            ? customer[item.key]
                                            : t("notRegistered"))}
                                </p>
                            </div>
                        ) : (
                            <div key={item.key}>
                                <p className="opt-subtitle">{item.label}</p>
                                <p className="opt-label">
                                    {customer &&
                                        (customer["extraData"][item.key]
                                            ? customer["extraData"][item.key]
                                            : t("notRegistered"))}
                                </p>
                            </div>
                        ))
                )}
            {customerFields.length === 0 &&
                ["fullName", "email", "phone", "notes"].map((key) => (
                    <>
                        {customer && customer[key] && (
                            <>
                                <p className="opt-subtitle">{t(`clientForm.${key}`)}</p>
                                <p className="opt-label">
                                    {customer &&
                                        (customer[key] ? customer[key] : t("notRegistered"))}
                                </p>
                            </>
                        )}
                    </>
                ))}
        </div>
    );
}
export default ProfileDataList;
